import { Pipe, PipeTransform } from '@angular/core';
import { PrinterSetup } from 'src/app/views/models/printer.model';

@Pipe({
  name: 'printerSetupFinder'
})
export class PrinterSetupFinderPipe implements PipeTransform {

  transform(setups: PrinterSetup[], id: number): PrinterSetup[] {
    return setups.filter(x => x.table_record_id === id);
  }

}
